<template>
    <div style="margin-top:-20px;">
        <goldDetailTable :parentData="parentData" :goldData.sync="goldData"></goldDetailTable>
        <goldDetailFlowRecord :parentData="parentData" :goldData.sync="goldData"></goldDetailFlowRecord>
        <goldDetailOriginInfo :parentData="parentData" :goldData.sync="goldData" style="margin-top:16px;"></goldDetailOriginInfo>
        <div class="spaceCenter">
            <a-button class="btn-blue-line" style="margin:30px 0;width:100px;" @click="goBack()">返回</a-button>
        </div>
    </div>
</template>

<script>
/**
 * 祺信融资tab页的祺信列表详情
 */
import {mapGetters} from "vuex"
import goldDetailTable from "@/components/gold-page/gold-detail-table"
import goldDetailOriginInfo from "@/components/gold-page/gold-detail-origin-info"
import goldDetailFlowRecord from "@/components/gold-page/gold-detail-flow-record"
import {getDetailApi} from '@/api/gold.js'
export default {
    components:{
        goldDetailTable,goldDetailOriginInfo,goldDetailFlowRecord
    },
    name:"goldFinancingDetail",
    data() {
        return {
            goldData:{},
        };
    },
    computed:{
        ...mapGetters({
            parentData:"app/getGoldDetailPrarms"
        })
    },
    methods: {
        getDetail(){ //融资申请点击查看祺信详情
            if(this.parentData.goldObj){
                let param = {...this.parentData.goldObj}
                getDetailApi(param,true)
                .then(res => {
                    this.goldData = res.data;
                }).catch(err => { console.log(err);});
            }
        },
        goBack(){
            this.$emit("goBack");
        }
    },
    activated() {
        this.getDetail();
    },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/financing-gold-detail-comp.vue